<template>
	<div>
		<breadcrumbs>
			<span>Mis cursos</span>
		</breadcrumbs>
		<section v-if="courses" class="course-section spad p-0">
			<div class="course-warp">
				<!-- <ul class="course-filter controls">
					<li class="control" :class="{ 'active mixitup-control-active': activeCategory == 'all'}" @click="activeCategory = 'all'">Todos</li>
					<li class="control" :class="{ 'active mixitup-control-active': activeCategory == 'blues'}" @click="activeCategory = 'blues'">Blues</li>
					<li v-for="category in categories" class="control" :key="category.id" :class="{ 'active, mixitup-control-active': activeCategory = category.id}" @click="activeCategory == category.id">{{ category.name }}</li>
				</ul>                                        -->
				<div class="row course-items-area">
					<course-card v-for="course in courses" v-bind:key="course.id" :course="course"></course-card>
				</div>
				<div v-if="courses.length == 0" class="text-center">
					<h4 class="mb-3"><b>¡Ooops!</b> Parece que no tienes ningún curso disponible.</h4>
					<h5>Es un buen momento para visitar <a href="https://chachiguitar.com/tienda/" target="_blank">nuestra tienda online</a>.</h5>
				</div>
			</div>
		</section>
		<div class="loader-container pt-5" v-else>
			<div class="loader mt-0 mb-0"></div>
		</div>
	</div>
</template>

<script>
import axios from 'axios';
import { API_URL } from '@/config.js'

import CourseCard from '@/components/CourseCard.vue'
import Breadcrumbs from '@/components/Breadcrumbs.vue'

export default {
	name: 'home',
	components: {
		CourseCard,
		Breadcrumbs
    },
	data() {
		return {
			categories: null,
			activeCategory: 'all',
			courses: null
		}
	},
	created() {
		this.getCourses();
		if (this.$store.getters.user && this.$store.getters.user.email) {
			this.checkNewCourses();
		}
	},
	methods: {
		getCourses() {
            let config = {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.getters.user.token
                }
            }
			axios.get(`${API_URL}/private/user/courses`, config)
				.then(response => {
					if (response.status == 200) {
						this.courses = response.data;
						console.log(response.data);
					} else {
						console.log(response);
					}
				})
				.catch(err => {
					console.log(err);
				});
		},
		checkNewCourses() {
			axios.post(`${API_URL}/public/user/sync`, { email: this.$store.getters.user.email })
				.then(response => {
					console.log(response.data.courses.length)
                    if (response.status == 200) {
                        if (response.data && response.data.courses && response.data.courses.length > 0) {
                            this.getCourses();
                        }
                    }
				})
				.catch((e) => {
					console.error(e)
				});
        }
	},
	computed: {
		userEmail () {
			return this.$store.getters.user.email
		}
	},
	watch: {
		userEmail() {
			this.checkNewCourses();
		}
	}
}
</script>

<style lang="scss" scoped>
	@import "@/variables.scss";
	.course-section {
		.course-warp {
			padding-top: 30px;
			.course-filter {
				.mixitup-control-active {
					color: $main-color-brown;
					border-bottom: 4px solid $main-color-brown;
				}
			}
		}
	}
	
	.course-section, .loader-container {
		min-height: calc(100vh - 208px);
		@media (max-width: 767px) {
            min-height: calc(100vh - 148px);
        }
	}
</style>
